import manifest from './catalogManifest.json';
import {readPackAsset} from './offlineAssets';
export {default as birdGuidePack} from './catalogManifest.json';
export interface BirdReferenceImage {path:string;author:string;license:string;source:string;sourceUrl:string;originalUrl:string;adapted:string;bytes:number;sha256:string}
export interface BirdReference {scientificName:string;name:string;canonicalName:string;sourceId:string;description?:string;descriptionUrl?:string;ebirdUrl?:string;image?:BirdReferenceImage}
export async function loadBirdCatalog(signal:AbortSignal):Promise<Map<string,BirdReference>>{
 const bytes=await readPackAsset(manifest,manifest.files[0],signal);
 const data=JSON.parse(new TextDecoder().decode(bytes));
 return new Map(data.records.map((record:BirdReference)=>[record.scientificName,record]));
}
export function readBirdImage(image:BirdReferenceImage,signal:AbortSignal){return readPackAsset(manifest,{name:image.path,bytes:image.bytes,sha256:image.sha256},signal);}
